export default "__VITE_ASSET__DChs6Y8A__"